import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { auth } from '../login/FirebaseConfig';
import { API_BASE_URL, CLOUDINARY_CLOUD_NAME } from '../../config/constants';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from 'react-bootstrap';

const TablaAbmCarousel = () => {
  const [docIds, setDocIds] = useState([]);
  const [info, setInfo] = useState([]); // Estado para almacenar la informacion de cada elemento del banner
  const [image, setImage] = useState(null);
  const [url, setUrl] = useState('');
  const [error, setError] = useState('');
  const [loadingDocId, setLoadingDocId] = useState(null); // Estado para la rueda de carga al eliminar un archivo
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [secciones, setSecciones] = useState([]); // Estado para las secciones
  const [seccion, setSeccion] = useState(''); // Estado para la sección seleccionada
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' }); // Estado para ordenar
  const COLLECTION_NAME = 'maincarousel';

  const user = auth.currentUser;

  const getImageUrl = (publicId) => {
    return `https://res.cloudinary.com/${CLOUDINARY_CLOUD_NAME}/image/upload/f_auto/${publicId}`;
  };

  const handleSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const sortFechaDeCreacion = () => {
    return [...docIds].sort((a, b) => {
      const aInfo = info.find((item) => item.id === a);
      const bInfo = info.find((item) => item.id === b);

      const aValue = aInfo ? aInfo[sortConfig.key] : '';
      const bValue = bInfo ? bInfo[sortConfig.key] : '';

      const fecha1 = aValue._seconds * 1000 + Math.floor(aValue._nanoseconds / 1e6);
      const fecha2 = bValue._seconds * 1000 + Math.floor(bValue._nanoseconds / 1e6);

      if (fecha1 < fecha2) return sortConfig.direction === 'asc' ? -1 : 1;
      if (fecha1 > fecha2) return sortConfig.direction === 'asc' ? 1 : -1;

      return 0;
    });
  }

  const sortedDocIds = React.useMemo(() => {
    if (!sortConfig.key) return docIds;
    if (sortConfig.key === "fechaCreacion")
      return sortFechaDeCreacion();
    else {
      return [...docIds].sort((a, b) => {
        const aInfo = info.find((item) => item.id === a);
        const bInfo = info.find((item) => item.id === b);

        const aValue = aInfo ? aInfo[sortConfig.key] : '';
        const bValue = bInfo ? bInfo[sortConfig.key] : '';

        if (typeof aValue === "string" && typeof bValue === "string") {
          const aValueLowercase = aValue.toLowerCase();
          const bValueLowerCase = bValue.toLowerCase();

          if (aValueLowercase < bValueLowerCase) return sortConfig.direction === 'asc' ? -1 : 1;
          if (aValueLowercase > bValueLowerCase) return sortConfig.direction === 'asc' ? 1 : -1;
          return 0;
        }
        else {
          if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
          if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
          return 0;
        }
      });
    }
  }, [docIds, info, sortConfig]);

  const handleUpload = async () => {
    if (!seccion || seccion === "Seleccione una sección") {
      toast.error('Por favor, selecciona una sección.');
      return;
    }
    try {
      setLoadingUpload(true);
      const idToken = await user.getIdToken();
      const formData = new FormData();
      formData.append('file', image);

      const { data } = await axios.post(`${API_BASE_URL}/subirImagen`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${idToken}`,
        },
      });
      const public_id = data.public_id;
      const ubicacion_seccion = await getUbicacionSeccion();
      await axios.post(`${API_BASE_URL}/crearDocumento`, { collectionName: COLLECTION_NAME, documentName: public_id, ruta: seccion, ubicacion: ubicacion_seccion }, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      });

      setUrl(data.secure_url);
      toast.success('¡Archivo cargado con exito!');
      fetchDocumentos();
    } catch (error) {
      console.error('Error al cargar la imagen:', error);
      toast.error('Error en la carga');
    } finally {
      setLoadingUpload(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const idToken = await user.getIdToken();
      setLoadingDocId(id); // Pone el id en el estado
      const responseDocumento = await axios.delete(`${API_BASE_URL}/eliminarDocumento/maincarousel/${id}`, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      });
      const responseArchivo = await axios.delete(`${API_BASE_URL}/eliminarArchivo/${id}`, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      });
      if (responseDocumento.status === 200 && responseArchivo.status === 200) {
        toast.success('¡Archivo eliminado con éxito!');
        setDocIds((prevDocIds) => prevDocIds.filter((docId) => docId !== id));
      } else {
        toast.error('Se produjo un error al eliminar el archivo.');
      }
    } catch (error) {
      toast.error('Se produjo un error al eliminar el archivo.');
    } finally {
      setLoadingDocId(null); // Resetea el estado luego de la eliminacion
    }
  };

  const fetchDocumentos = async () => {
    try {
      const idToken = await user.getIdToken();
      const response = await axios.post(`${API_BASE_URL}/getDocumentos`, { collectionName: 'maincarousel' }, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      });
      setDocIds(response.data.doc_ids);
      const docInfo = await Promise.all(
        response.data.doc_ids.map(async (docId) => {
          try {
            const docResponse = await axios.post(`${API_BASE_URL}/getInfoDocumento`, { docId, collectionName: 'maincarousel' }, {
              headers: {
                Authorization: `Bearer ${idToken}`,
              },
            });
            return docResponse.data.doc_info;
          } catch (err) {
            console.error(`Error fetching info for document ${docId}:`, err);
            return null;
          }
        })
      );
      setInfo(docInfo.filter(info => info !== null));
    } catch (err) {
      setError('Error obteniendo los documentos.');
      console.error(err);
    }
  };

  const fetchSecciones = async () => {
    try {
      const idToken = await user.getIdToken();
      const response = await axios.post(`${API_BASE_URL}/getDocumentos`, { collectionName: 'secciones' }, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      });

      // Guarda en activeDocs las secciones con estado "activado"
      const activeDocs = await Promise.all(response.data.doc_ids.map(async (docId) => {
        const docResponse = await axios.post(`${API_BASE_URL}/getInfoDocumento`, { docId, collectionName: 'secciones' }, {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        });
        return docResponse.data.doc_info.estado === 'activado' ? docId : null;
      }));

      const filteredActiveDocs = activeDocs.filter(docId => docId !== null);
      setSecciones(filteredActiveDocs);
      fetchSeccionesEstaticas();
    } catch (error) {
      setError('Error obteniendo las secciones.');
      console.error(error);
    }
  };

  const fetchSeccionesEstaticas = async () => {
    try {
      const idToken = await user.getIdToken();
      const response = await axios.post(`${API_BASE_URL}/getDocumentos`, { collectionName: 'seccionesestaticas' }, {
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      });
      setSecciones(prevSecciones => [
        ...new Set([...prevSecciones, ...response.data.doc_ids])
      ]);
    } catch (error) {
      setError('Error obteniendo las secciones.');
      console.error(error);
    }
  };

  const getUbicacionSeccion = async () => {
    try {
      const [response, responseEstaticas] = await Promise.all([
        axios.post(`${API_BASE_URL}/getInfoDocumento`, { collectionName: 'secciones', docId: seccion }).catch(error => error),
        axios.post(`${API_BASE_URL}/getInfoDocumento`, { collectionName: 'seccionesestaticas', docId: seccion }).catch(error => error)
      ]);
      if (response.status === 200)
        return response.data.doc_info.ubicacion;

      if (responseEstaticas.status === 200)
        return responseEstaticas.data.doc_info.ubicacion;

      return "Ninguna";
    } catch (error) {
      setError('Error inesperado al obtener la informacion de la seccion.');
    }
  };

  // Genera una fecha a partir del timestamp recibido
  const generarFecha = (timestamp) => {
    const { _seconds, _nanoseconds } = timestamp;
    const date = new Date(_seconds * 1000 + _nanoseconds / 1000000);

    // Genera el formato DD/MM/YYYY HH:MM:SS
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}hs`;
  };

  useEffect(() => {
    fetchDocumentos();
    fetchSecciones();
  }, []);

  return (
    <div className="container mt-4">
      <h2>Gestión de Banner Principal</h2>
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Seccion Subir Imagen */}
      <div className="upload-section p-3" style={{ border: "3px solid rgb(117, 117, 117)" }}>
        <h4>Subir nueva slide al banner: </h4>
        <input type="file" onChange={(e) => setImage(e.target.files[0])} className="form-control mb-3" />
        <select
          value={seccion}
          onChange={(e) => setSeccion(e.target.value)}
          className="form-select mb-3"
        >
          <option value="" disabled>Seleccione una sección</option>
          <option value="Ninguna">Ninguna</option>
          <option value="" disabled>----------------------</option>
          {secciones.map((sec, index) => (
            <option key={index} value={sec}>{sec}</option>
          ))}
        </select>
        <button onClick={handleUpload} className="btn btn-primary my-2" disabled={!image || loadingUpload}>
          {loadingUpload ? <Spinner animation="border" size="sm" /> : 'Subir Imagen'}
        </button>
      </div>

      {/* Tabla Carousel */}
      <h2 className='mt-3 mb-2'>Imágenes en Banner Inicial:</h2>
      <div className="table-responsive">
        <table className="table table-striped">
          <thead>
            <tr>
              <th onClick={() => handleSort('id')} style={{ cursor: 'pointer' }}>Imagen ID
                {sortConfig.key === 'id' && (sortConfig.direction === 'asc' ? ' 🔼' : ' 🔽')}
              </th>
              <th style={{ width: '50%' }}>Imagen</th>
              <th onClick={() => handleSort('fechaCreacion')} style={{ cursor: 'pointer' }}>Fecha de Creación
                {sortConfig.key === 'fechaCreacion' && (sortConfig.direction === 'asc' ? ' 🔼' : ' 🔽')}
              </th>
              <th onClick={() => handleSort('ruta')} style={{ cursor: 'pointer' }}>Ruta
                {sortConfig.key === 'ruta' && (sortConfig.direction === 'asc' ? ' 🔼' : ' 🔽')}
              </th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {sortedDocIds.length > 0 ? (
              sortedDocIds.map((id) => {
                const rutaInfo = info.find((ruta) => ruta.id === id);
                const fechaInfo = info.find((fechaCreacion) => fechaCreacion.id === id);
                return (
                  <tr key={id}>
                    <td>{id}</td>
                    <td>
                      <a href={getImageUrl(id)} target="_blank" rel="noopener noreferrer">
                        <img src={getImageUrl(id)} alt={`Imagen nro ${id}`} style={{ maxWidth: '75%' }} />
                      </a>
                    </td>
                    <td>{fechaInfo ? generarFecha(fechaInfo.fechaCreacion) : 'No disponible'}</td>
                    <td>{rutaInfo ? rutaInfo.ruta : 'No disponible'}</td>
                    <td>
                      <button
                        className="btn btn-danger"
                        onClick={() => handleDelete(id)}
                        disabled={loadingDocId === id}
                      >
                        {loadingDocId === id ? <Spinner animation="border" size="sm" /> : 'Eliminar'}
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6" className="text-center">No se encontraron documentos</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <h1 className="mb-3" style={{ textAlign: "center" }}>Vista Previa: </h1>
      <ToastContainer position="top-right" autoClose={5000} />
    </div>
  );
};

export default TablaAbmCarousel;
